/**
 * Account notices a Provider Owner's action sends the person it was done to:
 * an in-app Alerts row plus a content-free push (and an email from the
 * Lambda). The app opens `path` from either.
 */

export const ACCOUNT_NOTICE_PUSH_TYPE = 'ACCOUNT_NOTICE'

export type AccountNoticeKind = 'reactivated' | 'mfa-reset'

/** Where the app opens a notice (only these paths are followed from a push). */
export const ACCOUNT_NOTICE_PATHS: Record<AccountNoticeKind, string> = {
  reactivated: '/',
  'mfa-reset': '/account/login',
}

export const ACCOUNT_NOTICE_COPY: Record<
  AccountNoticeKind,
  { pushBody: string; alertTitle: string; alertBody: string }
> = {
  reactivated: {
    pushBody: 'Your account is active again.',
    alertTitle: 'Your account is active again',
    alertBody: 'Your organisation turned your account back on.',
  },
  'mfa-reset': {
    pushBody: 'Your two-factor login was reset. Open the app to set it up again.',
    alertTitle: 'Two-factor login was reset',
    alertBody:
      'Your organisation removed your authenticator app. Set it up again in Password & login email. If you didn’t ask for this, contact your coordinator.',
  },
}

/** The route to open for a notice push, or null when it isn't one of ours. */
export function accountNoticeRoute(data: Record<string, string>): string | null {
  if (data.type !== ACCOUNT_NOTICE_PUSH_TYPE) return null
  return Object.hasOwn(ACCOUNT_NOTICE_PATHS, data.kind) ? ACCOUNT_NOTICE_PATHS[data.kind as AccountNoticeKind] : '/'
}
